// extracted by mini-css-extract-plugin
export var inputContainer = "_ot-0";